/* The Vapetrix | Home hero slider (best sellers). Added 2026-09-30. */
(function () {
  if (window.__vtxHeroLoaded) return;
  window.__vtxHeroLoaded = true;
  var RM = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };


  /* GA4 tracking: reuses the site's existing gtag (falls back to dataLayer for GTM); silent if neither exists. */
  function send(name, params) {
    try {
      params = params || {};
      params.transport_type = 'beacon';
      if (typeof window.gtag === 'function') { window.gtag('event', name, params); }
      else if (window.dataLayer && typeof window.dataLayer.push === 'function') { var o = { event: name }; for (var k in params) o[k] = params[k]; window.dataLayer.push(o); }
    } catch (e) { /* never break the slider */ }
  }
  function slideInfo(el) {
    var s = el && el.closest ? el.closest('.vtx-hero__slide') : null;
    return s ? { slide_index: parseInt(s.getAttribute('data-hero-index'), 10) || 0, product_handle: s.getAttribute('data-hero-handle') || '' } : null;
  }

  function init(root) {
    if (!root || root.__vtxHero) return;
    root.__vtxHero = true;
    root.classList.add('is-js'); /* v6: enables the slide cross-fade styles (no-JS visitors keep plain slides) */
    var track = root.querySelector('.vtx-hero__track');
    var slides = [].slice.call(root.querySelectorAll('.vtx-hero__slide'));
    var dots = [].slice.call(root.querySelectorAll('.vtx-hero__dot'));
    var prevBtn = root.querySelector('.vtx-hero__btn--prev');
    var nextBtn = root.querySelector('.vtx-hero__btn--next');
    var toggle = root.querySelector('.vtx-hero__toggle');
    var n = slides.length;
    var viewed = {}, heroVisible = true, curIdx = 0;
    function viewIfReady() {
      if (!heroVisible || document.hidden || viewed[curIdx] || !slides[curIdx]) return;
      viewed[curIdx] = true;
      var si = slideInfo(slides[curIdx]);
      if (si) { si.slide_total = n; send('hero_slide_view', si); }
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { heroVisible = en[0].isIntersecting && en[0].intersectionRatio >= 0.5; viewIfReady(); }, { threshold: [0, 0.5] }).observe(root);
    }
    document.addEventListener('visibilitychange', viewIfReady);
    root.__vtxViewSlide = function (i) { curIdx = i; viewIfReady(); };
    root.addEventListener('click', function (e) {
      var t = e.target; if (!t || !t.closest) return;
      var a;
      if ((a = t.closest('.vtx-hero__cta'))) {
        var si = slideInfo(a); if (si) { si.destination_url = a.getAttribute('href') || ''; si.cta_text = (a.textContent || '').trim(); si.destination_type = a.getAttribute('data-hero-cta') || ''; send('hero_cta_click', si); }
      } else if ((a = t.closest('.vtx-hero__chip'))) {
        var sc = slideInfo(a); if (sc) { sc.device = a.getAttribute('data-hero-device') || ''; sc.device_label = (a.textContent || '').trim(); sc.destination_url = a.getAttribute('href') || ''; send('hero_chip_click', sc); }
      } else if ((a = t.closest('.vtx-hero__btn, .vtx-hero__dot'))) {
        var ctl = a.classList.contains('vtx-hero__dot') ? 'dot' : a.classList.contains('vtx-hero__btn--prev') ? 'arrow_prev' : a.classList.contains('vtx-hero__btn--next') ? 'arrow_next' : a.classList.contains('vtx-hero__toggle') ? 'pause_play' : '';
        if (ctl) {
          var cur = slides[curIdx] ? slideInfo(slides[curIdx]) : { slide_index: 0, product_handle: '' };
          cur.control = ctl; cur.from_slide_index = cur.slide_index;
          if (ctl === 'dot') cur.to_slide_index = dots.indexOf(a) + 1;
          else if (ctl === 'arrow_prev') cur.to_slide_index = ((curIdx - 1 + n) % n) + 1;
          else if (ctl === 'arrow_next') cur.to_slide_index = ((curIdx + 1) % n) + 1;
          delete cur.slide_index;
          send('hero_arrow_dot_click', cur);
        }
      }
    }, { passive: true, capture: true }); /* capture: runs before the slider's own handlers, so from/to indexes are correct */
    if (!track || n < 2) { root.__vtxViewSlide(0); return; }

    var idx = 0, programmatic = false, progTimer = 0, scrollTimer = 0, touchTimer = 0;
    var wantAuto = root.getAttribute('data-autoplay') === 'true' && !RM.matches;
    if (!wantAuto) root.setAttribute('data-autoplay', 'false');
    var holds = { hover: false, focus: false, touch: false, user: false, off: false };

    function refreshHeld() {
      var held = false;
      for (var k in holds) { if (holds[k]) held = true; }
      root.classList.toggle('is-held', held);
      root.classList.toggle('is-stopped', holds.user);
      track.setAttribute('aria-live', held || !wantAuto ? 'polite' : 'off');
    }
    function setActive(i) {
      idx = i;
      if (root.__vtxViewSlide) root.__vtxViewSlide(i);
      slides.forEach(function (s, j) {
        var on = j === i;
        s.classList.toggle('is-active', on);
        if ('inert' in s) s.inert = !on;
      });
      dots.forEach(function (d, j) {
        var on = j === i;
        d.classList.toggle('is-active', on);
        if (on) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }
    function width() { return track.clientWidth || 1; }
    function goTo(i, instant) {
      var wrapped = false;
      if (i >= n) { i = 0; wrapped = true; }
      if (i < 0) { i = n - 1; wrapped = true; }
      programmatic = true;
      clearTimeout(progTimer);
      progTimer = setTimeout(function () { programmatic = false; }, wrapped || instant ? 120 : 800);
      setActive(i);
      var behavior = (wrapped || instant || RM.matches) ? 'auto' : 'smooth';
      if (wrapped && !RM.matches) {
        track.classList.remove('is-wrap'); void track.offsetWidth; track.classList.add('is-wrap');
      }
      try { track.scrollTo({ left: i * width(), behavior: behavior }); } catch (e) { track.scrollLeft = i * width(); }
    }
    function onScroll() {
      if (programmatic) return;
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var i = Math.round(Math.abs(track.scrollLeft) / width());
        if (i >= n) i = n - 1;
        if (i !== idx) setActive(i);
      }, 60);
    }
    track.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { track.scrollLeft = idx * width(); });

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(idx - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(idx + 1); });
    dots.forEach(function (d, j) { d.addEventListener('click', function () { goTo(j); }); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { goTo(idx + 1); } else if (e.key === 'ArrowLeft') { goTo(idx - 1); }
    });

    if (toggle) toggle.addEventListener('click', function () {
      holds.user = !holds.user;
      toggle.setAttribute('aria-pressed', holds.user ? 'true' : 'false');
      toggle.setAttribute('aria-label', toggle.getAttribute(holds.user ? 'data-label-play' : 'data-label-pause'));
      refreshHeld();
    });

    /* pause on hover / focus / touch; resume shortly after touch ends */
    root.addEventListener('mouseenter', function () { holds.hover = true; refreshHeld(); });
    root.addEventListener('mouseleave', function () { holds.hover = false; refreshHeld(); });
    root.addEventListener('focusin', function () { holds.focus = true; refreshHeld(); });
    root.addEventListener('focusout', function () { holds.focus = false; refreshHeld(); });
    function touchStart() { clearTimeout(touchTimer); holds.touch = true; refreshHeld(); }
    function touchEnd() { clearTimeout(touchTimer); touchTimer = setTimeout(function () { holds.touch = false; refreshHeld(); }, 8000); }
    root.addEventListener('touchstart', touchStart, { passive: true });
    root.addEventListener('touchend', touchEnd, { passive: true });
    root.addEventListener('touchcancel', touchEnd, { passive: true });

    /* pause while off-screen or tab hidden */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        holds.off = !entries[0].isIntersecting || entries[0].intersectionRatio < 0.35;
        refreshHeld();
      }, { threshold: [0, 0.35, 0.6] }).observe(root);
    }
    document.addEventListener('visibilitychange', function () { holds.off = document.hidden; refreshHeld(); });

    /* the active dot's progress bar drives the auto-advance (so pausing the bar pauses the slider) */
    if (wantAuto) {
      root.addEventListener('animationend', function (e) {
        if (e.animationName === 'vtxHeroFill' && !root.classList.contains('is-held')) goTo(idx + 1);
      });
    }
    /* non-first images stay lazy until the page is idle or the visitor interacts, then the rest are fetched */
    var upgraded = false;
    function upgrade() {
      if (upgraded) return; upgraded = true;
      [].forEach.call(root.querySelectorAll('img[loading="lazy"]'), function (im) { im.loading = 'eager'; im.removeAttribute('fetchpriority'); });
    }
    ['pointerdown', 'touchstart', 'keydown'].forEach(function (ev) { root.addEventListener(ev, upgrade, { once: true, passive: true }); });
    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 2500); };
    window.addEventListener('load', function () { idle(function () { setTimeout(upgrade, 1500); }); });
    setActive(0);
    refreshHeld();
  }

  function boot() { [].forEach.call(document.querySelectorAll('[data-vtx-hero]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector && e.target.querySelector('[data-vtx-hero]');
    if (r) { r.__vtxHero = false; init(r); }
  });
})();
